import React from "react";
import { RicosNodeContextProvider } from "./../../../../../ricos-context";
import styles from "./layout-scss";
const LayoutCell = ({ node, nodeIndex, RicosNodesRenderer }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.cell }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { key: `children-${node.id}`, nodes: node.nodes ?? [] })));
};
const LayoutCellRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(LayoutCell, { key: node.id, node, ...props });
};
export {
  LayoutCell,
  LayoutCellRenderer
};
//# sourceMappingURL=cell.js.map
